import {QueryLangFilterOperator} from '../../../enums/query-lang-filter-operator';
import {QueryLangFilterCriterionCheckbox} from '../../../models/filters/query-lang-filter-criterion-checkbox';

export class FilterSupportedAssetsInput extends QueryLangFilterCriterionCheckbox {
    public override name: string = 'filter-assets-only-supported';
    public label: string = 'Supported';
    public override fieldNames: string[] = [];
    public override operator: QueryLangFilterOperator = QueryLangFilterOperator.EQ;

    public override isQuerySpecified(): boolean {
        return !!this.query;
    }

    public override apply(): void {
        return; // Not used.
    }
}
